import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import TextEditor from "../../../TextEditor/TextEditor";

import "./styles.css";

class QuestionCreatorFeedbackMenu extends Component {
  render() {
    return (
      <>
        {this.props.showQuestionFeedback && (
          <TextEditor
            editorType={{ name: "feedback", id: 2 }}
            changeQuestionFeedback={this.props.changeQuestionFeedback}
            textContent={this.props.feedbackContent}
            questionId={this.props.questionId}
            readOnly={this.props.readOnly}
          />
        )}
        <div className="question-creator-bottom-menu">
          {!this.props.readOnly ? (
            <button
              className="question-creator-bottom-menu-add-menu"
              onClick={() => this.props.toggleQuestionFeedback()}
            >
              {!this.props.showQuestionFeedback
                ? "Adicionar Feedback"
                : "Remover Feedback"}
            </button>
          ) : (
            <div></div>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({}, dispatch);
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(QuestionCreatorFeedbackMenu);
